module.exports = __webpack_public_path__ + "img/status-rank.684b6937.png";